export default {
  methods: {
    toQuery(){
      this.$parent.page = 1;
      this.$parent.init();
    },
  }
}
